import { sendVideoSessionsToServer as doSend } from 'videoanalytics'
import http from './http.service'

export default async function sendVideoSessionsToServer() {
    await doSend('/api/videoSession/save', http.post);
}